import { __generator } from "tslib";
import { takeLatest, call, select, put, all, takeEvery, throttle, } from 'redux-saga/effects';
import { URLS } from '@wix/da-url';
import { toggleMature, switchVersion, toggleTheme, toggleThemeDone, updateCommentsOrder, updateCommentsOrderDone, resendVerificationEmail, updateEmail, resendVerificationEmailFail, resendVerificationEmailSuccess, updateEmailFail, updateEmailSuccess, setViewMode, setThemeSkin, setTheme, fetchFeedbackCount, setFeedbackCount, setCookieSettingsSuccess, setCookieSettingsFail, setCookieAccepted, setCookieSettings, setAllCookiesAccepted, setCookieAcceptedAndReturn, } from './actions';
import { getTheme, getVerificationEmailAddress, getIsLoggedIn, getThemeSkin, getCookieSettings, } from './selectors';
import { request } from '../xhr';
import { openUserDropdown } from '../SiteHeader/redux/actions';
import { DeviationViewMode, } from '@wix/da-react-context/pkg/SessionContext';
import { ThemeSkin } from '@wix/da-react-context/pkg/ThemeContext';
import { restrictLoggedOut } from '../redux/loggedout';
import ddt from '@wix/da-ddt';
import { ReferralType } from '@wix/da-bi/pkg/constants';
var logger = ddt.createLogger('publicSession');
var FETCH_FEEDBACK_COUNT_WAIT = 5000;
function toggleMatureHandler(action) {
    var isLoggedIn, current, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.MATURE }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                current = action.payload.current;
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/settings/mature',
                        data: { flag: !current },
                    }, function () { return ({
                        success: true,
                    }); })];
            case 4:
                result = _a.sent();
                if (result && result.success) {
                    window.location.reload();
                }
                else {
                    if (result.error_code === 0) {
                        alert('Error, you are too young to enable mature content');
                        return [2 /*return*/];
                    }
                    alert('Failed to save mature setting');
                }
                return [2 /*return*/];
        }
    });
}
function switchVersionHandler(action) {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/settings/version',
                        data: { is_da_version_9_1: true }, // always true because switch back happens on old site
                    }, function () { return ({
                        success: true,
                    }); })];
            case 1:
                result = _a.sent();
                if (result && result.success) {
                    window.location.reload();
                }
                else {
                    alert('Failed to switch version please try again');
                }
                return [2 /*return*/];
        }
    });
}
function saveThemeHandler() {
    var currentTheme, currentThemeSkin, themeToSet, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getTheme)];
            case 1:
                currentTheme = _a.sent();
                return [4 /*yield*/, select(getThemeSkin)];
            case 2:
                currentThemeSkin = _a.sent();
                themeToSet = currentTheme;
                if (currentThemeSkin === ThemeSkin.GREEN) {
                    themeToSet = 'green';
                }
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/theme',
                        data: { theme: themeToSet },
                    }, function () { return ({
                        success: true,
                    }); })];
            case 3:
                result = _a.sent();
                if (!result || !result.success) {
                    alert('Failed to save theme setting');
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(toggleThemeDone())];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateCommentsOrderHandler(_a) {
    var data, result;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!payload) {
                    return [2 /*return*/];
                }
                data = {
                    order: payload.order,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/settings/comments_order',
                        data: data,
                    }, function () { return ({
                        success: true,
                    }); })];
            case 1:
                result = _b.sent();
                if (!result || !result.success) {
                    alert('Failed to save comments order');
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(updateCommentsOrderDone(payload.order))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function resendVerificationEmailHandler() {
    var data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(openUserDropdown())];
            case 1:
                _a.sent();
                data = {};
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/resend_verification_email',
                        data: data,
                    }, function () { return ({
                        success: true,
                    }); })];
            case 2:
                result = _a.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 4];
                alert('Failed to resend email');
                return [4 /*yield*/, put(resendVerificationEmailFail())];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, put(resendVerificationEmailSuccess())];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateEmailHandler(_a) {
    var email, currentEmail, data, result;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!payload) {
                    return [2 /*return*/];
                }
                email = payload.email;
                return [4 /*yield*/, select(getVerificationEmailAddress)];
            case 1:
                currentEmail = _b.sent();
                if (!(email === currentEmail)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(updateEmailSuccess(email))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                data = { email: email };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/update_email',
                        data: data,
                    }, function () { return ({
                        success: true,
                    }); })];
            case 4:
                result = _b.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(updateEmailFail(email))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, put(updateEmailSuccess(email))];
            case 7:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function setAllCookiesAcceptedHandler() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(setCookieSettings({ functional: true, marketing: true, analytics: true }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(setCookieAccepted())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function setCookieAcceptedHandler() {
    var types, data, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getCookieSettings)];
            case 1:
                types = _a.sent();
                data = {
                    accepted: true,
                    type_functional: types.functional,
                    type_marketing: types.marketing,
                    type_analytics: types.analytics,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: '/user/cookiesettings/save',
                        data: data,
                    }, function () { return ({
                        success: true,
                    }); })];
            case 2:
                result = _a.sent();
                if (!(!result || !result.success)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(setCookieSettingsFail())];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, put(setCookieSettingsSuccess())];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function setCookieAcceptedAndReturnHandler() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(setCookieSettingsSuccess, function () {
                    return window.location.assign(URLS.PRIVACY);
                })];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(setCookieAcceptedHandler)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function setViewModeHandler(_a) {
    var data, result;
    var nextViewMode = _a.payload.nextViewMode;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                // only save normal/theater, fullscreen is irrelevant
                if (nextViewMode === DeviationViewMode.Fullscreen) {
                    return [2 /*return*/];
                }
                data = {
                    view_mode: nextViewMode,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'deviation/set_view_mode',
                        data: data,
                    }, function () { return ({ success: true }); })];
            case 1:
                result = _b.sent();
                if (!result || !result.success) {
                    logger.error('Failed to persist new view mode', nextViewMode);
                }
                return [2 /*return*/];
        }
    });
}
function fetchFeedbackCountHandler() {
    var result;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: "/unread",
                }, function () { return ({ counts: { feedback: 1 } }); })];
            case 1:
                result = _c.sent();
                if (!(result && !result.error)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(setFeedbackCount((_b = (_a = result === null || result === void 0 ? void 0 : result.counts) === null || _a === void 0 ? void 0 : _a.feedback) !== null && _b !== void 0 ? _b : 0))];
            case 2:
                _c.sent();
                _c.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(switchVersion, switchVersionHandler),
                    takeLatest(toggleMature, toggleMatureHandler),
                    takeLatest(toggleTheme, saveThemeHandler),
                    takeLatest(setTheme, saveThemeHandler),
                    takeLatest(setThemeSkin, saveThemeHandler),
                    takeLatest(updateCommentsOrder, updateCommentsOrderHandler),
                    takeLatest(resendVerificationEmail, resendVerificationEmailHandler),
                    takeLatest(updateEmail, updateEmailHandler),
                    takeEvery(setViewMode, setViewModeHandler),
                    takeEvery(setCookieAccepted, setCookieAcceptedHandler),
                    takeEvery(setCookieAcceptedAndReturn, setCookieAcceptedAndReturnHandler),
                    takeEvery(setAllCookiesAccepted, setAllCookiesAcceptedHandler),
                    throttle(FETCH_FEEDBACK_COUNT_WAIT, fetchFeedbackCount, fetchFeedbackCountHandler),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map